export default {
  INCREASE_FONT_SIZE: (state) => {
    state.fontSize++
  },

  DECREASE_FONT_SIZE: (state) => {
    state.fontSize--
  }
}
